<div class="content-wrapper">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>

        <div class="card" *blockUI="'section-block'">

            <div class="col-12">
                <div class="card-body" *ngIf="isReadonly">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <div class="col">
                            <h4 class="card-title mb-0">{{data.name}}</h4>
                            <h6 class="card-subtitle text-muted mt-1" *ngIf="data.categoryName">{{data.categoryName}}
                            </h6>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="card-text mt-1" *ngIf="data.labels">
                            <div class="badge badge-pill badge-primary" *ngFor="let label of data.labels">
                                <i data-feather="tag" class="mr-1"></i> {{label.labelName}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" *ngIf="!isReadonly">
                    <div class="card-body">
                        <div class="row ml-1">
                            <div class="col-xl-4 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="name">Ürün Adı</label>
                                    <input type="text" class="form-control" id="name"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.name"
                                        (ngModelChange)="data.name = $event.toUpperCase()" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="currencyName">Para Birimi</label>
                                    <div class="form-group" *ngIf="!isReadonly">
                                        <select class="form-control" id="currency" *ngIf="!isReadonly"
                                            [(ngModel)]="data.currencyId">
                                            <option *ngFor="let item of currencies" [value]="item.id"
                                                [selected]="data.currencyId == item.id">
                                                {{item.currencyName}}</option>
                                        </select>
                                    </div>
                                    <input type="text" class="form-control" id="currencyName" *ngIf="isReadonly"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.currencyName" />
                                </div>
                            </div>
                            <div class="col-xl-1 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="unitTypeName">Birim</label>
                                    <div class="form-group" *ngIf="!isReadonly">
                                        <select class="form-control" id="currency" *ngIf="!isReadonly"
                                            [(ngModel)]="data.unitTypeId">
                                            <option *ngFor="let item of unitTypes" [value]="item.id"
                                                [selected]="data.unitTypeId == item.id">
                                                {{item.unitTypeName}}</option>
                                        </select>
                                    </div>
                                    <input type="text" class="form-control" id="unitTypeName" *ngIf="isReadonly"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.unitTypeName" />
                                </div>
                            </div>

                            <div class="col-xl-2 col-md-8 col-12">
                                <label for="categoryName">Kategori</label>
                                <div class="form-group" *ngIf="!isReadonly">
                                    <select class="form-control" id="currency" *ngIf="!isReadonly"
                                        [(ngModel)]="data.categoryId">
                                        <option *ngFor="let item of categories" [value]="item.id"
                                            [selected]="data.categoryId == item.id">
                                            {{item.categoryName}}</option>
                                    </select>
                                </div>

                                <div class="form-group" *ngIf="isReadonly">
                                    <input type="text" class="form-control" id="categoryName"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.categoryName" />
                                </div>
                            </div>
                            <div class="col-xl-1 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="criticalStock">Kiritik Stok</label>
                                    <input type="text" class="form-control" id="criticalStock"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.criticalStock" />
                                </div>
                            </div>

                            <div class="col-xl-2 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="criticalStock">Marka</label>
                                    <ng-select [items]="brands" bindLabel="name" bindValue="id" groupBy="brandName"
                                        [(ngModel)]="data.brandModelId">
                                        <ng-template ng-optgroup-tmp let-item="item">
                                            {{ item.brandName || 'Unnamed group' }}
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                        </div>

                        <div class="row ml-1">
                            <div class="col-xl-2 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="barcode">Barkod</label>
                                    <input type="text" class="form-control" id="barcode"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.barcode" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="code">Kod</label>
                                    <input type="text" class="form-control" id="code"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.code" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="purchasePrice">Alış Fiyat</label>
                                    <input type="text" class="form-control" id="purchasePrice"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.purchasePrice" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-8 col-12">
                                <label for="saleTax">Alış Vergi</label>
                                <div class="form-group" *ngIf="!isReadonly">
                                    <select class="form-control" id="currency" *ngIf="!isReadonly"
                                        [(ngModel)]="data.saleTaxId">
                                        <option *ngFor="let item of taxes" [value]="item.id"
                                            [selected]="data.saleTaxId == item.id">
                                            {{item.taxRate}}</option>
                                    </select>
                                </div>
                                <div class="form-group" *ngIf="isReadonly">
                                    <input type="text" class="form-control" id="saleTax"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.saleTax" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-8 col-12">
                                <div class="form-group">
                                    <label for="salePrice">Satış Fiyat</label>
                                    <input type="text" class="form-control" id="salePrice"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.salePrice" />
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-8 col-12 ">
                                <label for="purchaseTax">Satış Vergi</label>

                                <div class="form-group" *ngIf="!isReadonly">
                                    <select class="form-control" id="currency" *ngIf="!isReadonly"
                                        [(ngModel)]="data.purchaseTaxId">
                                        <option *ngFor="let item of taxes" [value]="item.id"
                                            [selected]="data.purchaseTaxId == item.id">
                                            {{item.taxRate}}</option>
                                    </select>
                                </div>
                                <div class="form-group" *ngIf="isReadonly">
                                    <input type="text" class="form-control" id="purchaseTax"
                                        [attr.readonly]="isReadonly ? true : null" [(ngModel)]="data.purchaseTax" />
                                </div>
                            </div>
                            <div class="col-xl-4 col-md-8 col-12 ">
                                <div class="form-group">
                                    <label for="labels">Etiketler</label>
                                    <div class="chip-container">
                                        <div *ngFor="let label of data.labels" class="badge badge-pill badge-info"
                                            style="margin-right: 5px; margin-top: 3px;">
                                            {{ label.labelName }}
                                            <button type="button" class="close" aria-label="Close"
                                                (click)="removeLabel(label.productLabelId)">
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                    </div>
                                    <textarea class="form-control" id="labelTextarea" rows="3"
                                        placeholder="Etiket Giriniz." [(ngModel)]="newLabel"
                                        (keydown.enter)="addLabel($event)">
                                            </textarea>
                                </div>
                            </div>
                            <div class="col-xl-2 col-md-3 col-10">
                                <div class="form-group">
                                    <label></label>
                                    <div class="form-check-group">
                                        <div class="form-check">
                                            <input type="radio" [checked]="data!.productType === true" [value]="true"
                                                id="product" class="form-check-input"
                                                (change)="updateProductType($event)" />
                                            <label class="form-check-label" for="product">
                                                <span class="radio-custom"></span> Ürün
                                            </label>
                                        </div>
                                        <div class="form-check">
                                            <input type="radio" [checked]="data.productType === false"
                                                (change)="updateProductType($event)" [value]="false" id="service"
                                                class="form-check-input" />
                                            <label class="form-check-label" for="service">
                                                <span class="radio-custom"></span> Hizmet
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row d-flex justify-content-end mb-1 mr-1">
                    <button type="button" class="btn btn-icon btn-success ml-1"
                        *ngIf="!isReadonly && authService.isEndpointStatus('PUT.Updateing.UpdateProduct')"
                        (click)="updateData()" rippleEffect>
                        <span [data-feather]="'save'"></span>
                    </button>

                    <button type="button" class="btn btn-icon btn-warning ml-1" *ngIf="!isReadonly"
                        (click)="toggleReadonly()" rippleEffect>
                        <span [data-feather]="'x'"></span>
                    </button>

                    <button type="button" class="btn btn-icon btn-warning ml-1" *ngIf="isReadonly"
                        (click)="toggleReadonly()" rippleEffect>
                        <span [data-feather]="isReadonly ? 'edit' : 'x'"></span>
                    </button>

                    <button type="button" class="btn btn-icon btn-danger ml-1"
                        *ngIf="data.id != 1 && authService.isEndpointStatus('DELETE.Deleteing.RemoveProduct')" appDelete
                        controller="products" [id]="data.id" (callback)="eventDelete()" rippleEffect>
                        <span [data-feather]="'trash'"></span>
                    </button>
                </div>
            </div>
        </div>

        <ul ngbNav #nav="ngbNav" class="nav-tabs">
            <li ngbNavItem>
                <a ngbNavLink>Manuel Stok Haraketleri</a>
                <ng-template ngbNavContent>
                    <div class="card">
                        <div class="col-xl-6 col-md-6 col-12 mt-1 mb-1">
                            <button type="button" class="btn btn-success btn-sm ml-2 d-flex align-items-center"
                                *ngIf="authService.isEndpointStatus('POST.Writing.CreateProductMovement')"
                                (click)="showCrateProductMovement()">
                                Stok Hareket Ekle
                            </button>
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Depo Adi</th>
                                        <th>Adet</th>
                                        <th>Hareket Tarihi</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of data.productMovements">
                                        <td>{{ item.warehouseName }}</td>
                                        <td>{{ item.productCount }}</td>
                                        <td>{{ item.cratedAt | date: 'dd.MM.yyyy HH:mm' }}</td>

                                        <td class="row">
                                            <button type="button" class="btn btn-icon btn-flat-danger btn-sm" appDelete
                                                controller="ProductMovements" [id]="item.id"
                                                *ngIf="authService.isEndpointStatus('DELETE.Deleteing.RemoveProductMovement')"
                                                (callback)="getByIdProduct(data.id)" rippleEffect>
                                                <span [data-feather]="'trash'"></span></button>
                                            <button type="button"
                                                *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateProductMovement')"
                                                class="btn btn-icon btn-flat-warning btn-sm" rippleEffect
                                                (click)="showUpdateProductMovement(item)">
                                                <span [data-feather]="'edit'"></span></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink>Seri Numarası</a>
                <ng-template ngbNavContent>
                    <div class="card">
                        <div class="col-xl-6 col-md-6 col-12 mt-1 mb-1">
                            <button type="button" class="btn btn-success btn-sm ml-2 d-flex align-items-center"
                                *ngIf="authService.isEndpointStatus('POST.Writing.CreateSerialProduct')"
                                (click)="createSerialNo()">
                                Seri No Ekle
                            </button>
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Seri No</th>
                                        <th>Durum</th>
                                        <th>Eklenme Tarihi</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="data.serials.length>0">
                                    <tr *ngFor="let item of data.serials">

                                        <td>
                                            <span *ngIf="editingSerail !== item.id">{{ item.serialNo
                                                }}</span>
                                            <input *ngIf="editingSerail === item.id" type="string" maxlength=""
                                                [(ngModel)]="item.serialNo" class="form-control" />
                                        </td>
                                        <td>
                                            <div
                                                [ngClass]="item.isDeleted ? 'badge badge-danger' : 'badge badge-success'">
                                                {{ item.isDeleted ? 'Stokta Yok' : 'Stokta' }}
                                            </div>

                                        </td>
                                        <td>{{ item.createdAt | date: 'dd.MM.yyyy HH:mm' }}</td>
                                        <td class="row">
                                            <button *ngIf="editingSerail !== item.id && !item.isDeleted" type="button"
                                                class="btn btn-icon btn-flat-warning btn-sm" rippleEffect
                                                (click)="editSerial(item)">
                                                <span [data-feather]="'edit'"></span>
                                            </button>
                                            <button *ngIf="editingSerail === item.id && 
                                                authService.isEndpointStatus('PUT.Updateing.UpdateSerialProduct')"
                                                type="button" class="btn btn-icon btn-flat-success btn-sm" rippleEffect
                                                (click)="saveProductSerial(item)">
                                                <span [data-feather]="'save'"></span>
                                            </button>
                                            <button *ngIf="editingSerail === item.id" type="button"
                                                class="btn btn-icon btn-flat-danger btn-sm" rippleEffect
                                                (click)="cancelEdit()">
                                                <span [data-feather]="'x'"></span>
                                            </button>
                                            <button
                                                *ngIf="!item.isDeleted && authService.isEndpointStatus('DELETE.Deleteing.RemoveSerialProduct')"
                                                type="button" class="btn btn-icon btn-flat-danger btn-sm" rippleEffect
                                                (click)="removeProductSerial(item.id)">
                                                <span [data-feather]="'trash'"></span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-template>
            </li>
            <li ngbNavItem>
                <a ngbNavLink>Alt Ürünler</a>
                <ng-template ngbNavContent>
                    <div class="card">
                        <div class="col-xl-6 col-md-6 col-12 mt-1 mb-1">
                            <button type="button" class="btn btn-success btn-sm ml-2 d-flex align-items-center"
                                (click)="showSubProductCrate()">
                                Alt Ürün Ekle
                            </button>
                        </div>
                        <div class="card-body table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Bağlı Ürün Adı</th>
                                        <th>Adet</th>
                                        <th>Eklenme Tarihi</th>
                                        <th>#</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of data.subProducts">
                                        <td>{{ item.subConnectProductName }}</td>
                                        <td>
                                            <span *ngIf="editingSubProductId !== item.subProductId">{{ item.count
                                                }}</span>
                                            <input *ngIf="editingSubProductId === item.subProductId" type="number"
                                                [(ngModel)]="tempCount" class="form-control" />
                                        </td>
                                        <td>{{ item.createdAt | date: 'dd.MM.yyyy HH:mm' }}</td>
                                        <td>
                                            <button *ngIf="editingSubProductId !== item.subProductId" type="button"
                                                class="btn btn-icon btn-warning mr-1" rippleEffect
                                                (click)="editSubProduct(item)">
                                                <span [data-feather]="'edit'"></span>
                                            </button>
                                            <button *ngIf="editingSubProductId === item.subProductId" type="button"
                                                class="btn btn-icon btn-success mr-1" rippleEffect
                                                (click)="saveSubProduct(item)">
                                                <span [data-feather]="'save'"></span>
                                            </button>
                                            <button *ngIf="editingSubProductId === item.subProductId" type="button"
                                                class="btn btn-icon btn-danger mr-1" rippleEffect
                                                (click)="cancelEdit()">
                                                <span [data-feather]="'x'"></span>
                                            </button>
                                            <button type="button" class="btn btn-icon btn-warning" rippleEffect
                                                (click)="removeSubProducts(item.subProductId)">
                                                <span [data-feather]="'trash'"></span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-2"></div>
    </div>
</div>